import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../../actions/consumer.actions";
import { FundingBalanceState } from "../../models/funding-balance-state";

const initialState: FundingBalanceState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.fundingBalance.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerActions.fundingBalance.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(ConsumerActions.fundingBalance.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function fundingBalanceReducer(
	state: FundingBalanceState | undefined,
	action: Action
): FundingBalanceState {
	return reducer(state, action);
}
